import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import React, { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import Icon, { IconTypes } from 'components/basic/Icon';
import type { menuItems } from 'components/pagesComponents/landing/Main/constants';

import s from './MenuItem.module.scss';

interface Props {
  item: (typeof menuItems)[0];
}

export default function MenuItem({ item }: Props): JSX.Element {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const closed = useDebouncedCallback(() => {
    setMenuOpen(false);
  }, 100);
  const items = item.items.map(subItem => (
    <div
      key={subItem.href}
      onClick={(): void => {
        logEvent('Web_Site_Header_Link_Clicked', { link_url: subItem.href });
      }}
    >
      <a href={subItem.href} className={s.link}>
        {subItem.text}
      </a>
    </div>
  ));

  return (
    <div className={s.wrapper}>
      <div
        className={s.header}
        onMouseEnter={(): void => {
          closed.cancel();
          setMenuOpen(true);
        }}
        onMouseLeave={closed}
      >
        {item.header}
        <Icon
          className={s.icon}
          icon={IconTypes.arrowRight}
          size={20}
          color="white"
        />
      </div>
      <div
        onMouseEnter={(): void => {
          closed.cancel();
          setMenuOpen(true);
        }}
        onMouseLeave={closed}
        className={cn(s.menu, {
          [s.open]: isMenuOpen,
        })}
      >
        {items}
      </div>
    </div>
  );
}
